export enum PhLinesGrnStatusEnum{
    OPEN ='OPEN',
    DONE ='DONE',
}